/**
 * Appends each user action (click, selection, input, etc.) to an array in the response object.
 * Each entry contains details about the event, selection, or input.
 * @param {Object} responseObj - The current response object (should have an 'events' array).
 * @param {Object} payload - The action payload to add.
 * @returns {Object} - The updated response object.
 */
export function updateServiceTitanResponse(responseObj, payload) {
  if (!payload) return responseObj;
  // Clone to avoid mutation
  const updated = { ...responseObj };

  // Initialize events array if not present
  if (!Array.isArray(updated.events)) {
    updated.events = [];
  }

  // Add timestamp to the payload
  const eventEntry = {
    ...payload,
    timestamp: new Date().toISOString(),
  };

  // Append the event entry to the events array
  updated.events.push(eventEntry);
  return updated;
}
